export default "__VITE_ASSET__43ee9464__$_?component__"